<template>
  <Card :footerDivider="false" :title="$t('usernameRetrievalNoUsername.general.title')">
    <template v-slot:content>
      <div>
        <p>{{ $t('usernameRetrievalNoUsername.general.description') }}</p>
      </div>
    </template>
    <template v-slot:footer>
      <div class="footer-cta footer-cta--left">
        <CustomButton
          @click="onSubmit"
          trackId="forgotUsername"
          :pendingState="pending"
          :buttonColor="ButtonColor.PRIMARY"
          buttonId="forgot-username-register-button"
        >
          {{ $t('usernameRetrievalNoUsername.submit.text') }}
        </CustomButton>
      </div>
    </template>
  </Card>
</template>
<script setup lang="ts">
import { ButtonColor, Card, CustomButton } from 'de-zurich-ui-library'
import { navigate } from '@/utils/NavigationUtils'
import { ref } from 'vue'

const pending = ref(false)

const onSubmit = (): void => {
  pending.value = true
  navigate(globalThis.ENV_CONFIG?.REDIRECTS.LOGIN_PAGE)
}
</script>
<style lang="scss" scoped>
span.error-message {
  font-size: 24px;
  color: var(--input-color-error);
}

b.error-message {
  padding-left: 5px;
  color: var(--input-color-error);
}
</style>
